import React, { useState,useContext } from "react";
import { TextField,InputAdornment ,IconButton} from "@mui/material";
import style from "../../../styles/mystyle.module.css";
import { useTranslation } from "next-i18next";
import { Grid } from "@mui/material";
import config from "../../../next.config.js";
import {constants} from '../../../constants'
import Link from "next/link";
// import LoadingButton from "@mui/lab/LoadingButton";
import Stack from "@mui/material/Stack";
// import { styled } from "@mui/system";
import { useRouter } from "next/router";
import {loginUser,setLoginCookies,getDataUser} from "../../helpers/auth";
import {encryption} from "../../helpers/auth";
import {getTermsByVocabCode} from "../../helpers/global/term/term";
import axios from "axios";
import Visibilityoff from '@mui/icons-material/VisibilityOff'
import Visibility from '@mui/icons-material/Visibility'
import AlertDialog from '../../components/Dialogs/AlertDialog'
// import Active from '../Activateaccount/Active'
import { encryptLocalStorage } from "../../helpers/helpers"
import {Customebtn , CustomeForm} from "../StyledComponent/Login.style"
import { useLocale } from '../../../context/language/language.provider';
import TermsContext from "../../../context/Trems"
export async function loginHandler(username,password,router){
let message="null"

 await loginUser(username, password) .then(async res => {
        if (res.data.data && res.data.data.token!=null) {
          await getTermsByVocabCode("user-types")
          .then(async termRes => {
            let DataUser
            let userType = JSON.parse(termRes).filter(i => i.id == res.data.data.userTypeId)
            if (userType && userType.length > 0 && userType[0].code != "system-admin") {
              DataUser = await getDataUser(res.data.data.langId, res.data.data.token)
              
            } else {
              DataUser = null
            }
            var configLangugae = {
              method: 'get',
              url: config.basePath + '/api/globals/languages/get',
              headers: {
                  'Content-Type': 'application/json'
              },
              params: {}
          }
            await axios(configLangugae)
            .then((resp2) => {
              let langCode=resp2.data.data.filter(x=>x.id==res.data.data.langId)[0].code
              // changeLanguage(langCode)
              res.data.data.langCode=langCode
              // if( router.pathname== "/user-ms/login"){
              //   router.push({ pathname: '/', query: router.query }, router.asPath, { locale: langCode })
              //    }else{
              //     router.push({ pathname: router.pathname, query: router.query }, router.asPath, { locale: langCode }) 
              //    }
              message=res.data.data
        }).catch(err => console.log(err))
  
            await axios
              .get(`${config["basePath"]}/api/user/userPermission`, {
                headers: {
                  "Content-Type": "application/json",
                  ["Authorization"]: encryption(
                    "Bearer " + res.data.data.token
                  )
                }
              })
              .then(perm => {

                // console.log("perm=========>",perm)
                if (perm.data.data.length > 0) {
              

               
             
                  encryptLocalStorage("userPermission", perm.data.data);
                } else {
                }
              })
              .catch(err => err);
            
            await getTermsByVocabCode("transaction-channels")
              .then(async termRes => {
                
            // console.log("termRes------------->",JSON.parse(termRes).filter(i => i.code == "web")[0].id)
            
                await axios
                  .post(
                    `${config["basePath"]}/api/user/transactionChannels`,
                    {
                      data: {
                        userTypeId: [res.data.data.userTypeId],
                        transactionChannelId: [JSON.parse(termRes).filter(i => i.code == "web")[0].id]
                      },
                      headers: {
                        "Content-Type": "application/json",
                        "Accept-Language": router.locale,
                        Authorization: encryption(
                          "Bearer " + res.data.data.token
                        )
                      }
                    }
                  )
                  .then(transactionChannelsResp => {
                    // console.log("transactionChannelsResp==========>",transactionChannelsResp)
                    if(transactionChannelsResp.data.data.length > 0) {
                      let data={...DataUser,...res}
                      
                      setLoginCookies(data);
                        message=res.data.data
                    } else {
                        message= "هذا المستخدم غير مسموح لة الدخول الى نظام الويب"
                    }
               
                }) .catch(err =>console.log(err));
            
              })  .catch(err => {
                console.log(err);
              });
            }).catch(err => (err))
          } else {
              if(res.data.data && res.data.data.passwordTemp==true){
                var configLangugae = {
                  method: 'get',
                  url: config.basePath + '/api/globals/languages/get',
                  headers: {
                      'Content-Type': 'application/json'
                  },
                  params: {}
              }
               await axios(configLangugae)
                .then((resp2) => {
                  let langCode=resp2.data.data.filter(x=>x.id==res.data.data.langId)[0].code
               
                  // changeLanguage(langCode)
                  res.data.data.langCode=langCode
                  message=res.data.data
            }).catch(err => console.log(err))
         
              }
              else{
             
                message=  res.data.data.subErrors[0].message
              }
          
          }
          return message
    }).catch(err=>console.log(err))

    return message
}
function LoginHome() {
  const [loading, setLoading] = React.useState(false);
  const {changeLanguage } = useLocale();
  const { t,i18n } = useTranslation("common");
  const { locale} = useRouter();
  const router = useRouter();
  const [inputsValues, setInputsValues] = useState({
    username: "",
    password: "",
    errorArray: [
      { username: false, message: t("mandatory-field") },
      { message: t("mandatory-field"), password: false }
    ]
  });
  const vocabTerms = useContext(TermsContext)

  const [userTypes,setUserTypes] =useState(vocabTerms.entityTypes)
  const [responseMessgae,setResponseMessage]=React.useState({type:null,message:null,show:false})
  const handleChange = e => {
    const value = { ...inputsValues };
    value[e.target.name] = e.target.value;
    handleError(value, e.target.name);
    setInputsValues(value);
  };
const [showActivateAccount,setShowActivateAccount]= useState({show:false});

  const handleSubmit =  e => {
    e.preventDefault();

    try {
      if (
        handleError(inputsValues, "username") &&
        handleError(inputsValues, "password")
      ) {
        setLoading(true);
        // let message=null
        loginHandler(inputsValues.username, inputsValues.password,router).then(res=>{
          console.log("res========>",res)
          setLoading(false);
         
            if(res.passwordTemp==true){
                router.push({ pathname: "/user-ms/active-account", query: {
                  username:inputsValues.username,tempPassword:inputsValues.password}}, { pathname: "/user-ms/active-account", query: {username:inputsValues.username,tempPassword:inputsValues.password}}, { locale: res.langCode } )
              }
              else{
                // console.log("res==========>",res)
                if(res.token){
                  changeLanguage(res.langCode)
                  router.push({ pathname: '/', query: router.query,asPath:"/" }, {asPath:"/"}, { locale: res.langCode })

                }
                else{
                    responseMessgae["show"]=true 
                    responseMessgae["type"]="error"
                    responseMessgae["message"]=res
                    setResponseMessage({...responseMessgae})
                }
            //       if((typeof res=="object")&&res.passwordTemp==false){
     
         
            //          if(router.query.next){
            //             router.push(router.query.next)
            //         }
            //         else{
                     
            //               router.push({ pathname: '/', query: router.query,asPath:"/" }, {asPath:"/"}, { locale: res.langCode })
            //      }    
            //       }
                  
            //       else{
                  
      
            //       }
            
 
              }
        })

                           
                            // return message

      } else {
        handleError(inputsValues, "name");
        handleError(inputsValues, "password");
        setInputsValues({ ...inputsValues });
      }
    } catch (err) {
      // console.log("err============>",err)
    }
  };

  const handleError = (value, name) => {
    let formIsValide = true;
    if (name == "username") {
      if (value.username == "") {
        formIsValide = false;
        value.errorArray[0].username = true;
      } else {
        value.errorArray[0].username = false;
      }
      return formIsValide;
    }

    if (name == "password") {
      if (value.password == "") {
        formIsValide = false;
        value.errorArray[1].password = true;
      } else {
        value.errorArray[1].password = false;
      }
      return formIsValide;
    }
  };
  const [showPassord,setShowPassord]=useState(false)
  const handleClickShowPassword = () => {
    setShowPassord(!showPassord);
};

  return (
      <>
    {/* {console.log("showActivateAccount==========>",showActivateAccount)} */}
    {showActivateAccount.show==false?<div className={style.SectionContainer}>
      <div className={style.allcard}>
        <div className={style.cardLogin}>
          <div className={style.card1}>
            <form onSubmit={handleSubmit}>
     
              <div className={style.card3}>
                <div className={style.HeaderLogin}> {t("SIGNIN")} </div>
                <p className={style.accountcreation}>{t("Welcomtohakeem")}</p>

                <br />

                <Grid container spacing={2} style={{ paddingBottom: "10px",margin:0,width:"100%" }}>
                  <Grid
                    className="griditem"
                    item
                    lg={12}
                    xl={12}
                    sm={12}
                    md={12}
                    xs={12}
                    sx={{ paddingBottom: "10px" }}
                  >
                    <CustomeForm
                      className="textfield"
                      label={t("lblUserName")}
                      error={inputsValues.errorArray[0].username}
                      // className="textfield"
                      onChange={e => handleChange(e)}
                      variant="outlined"
                      name="username"
                      helperText={
                        inputsValues.errorArray[0].username
                          ? inputsValues.errorArray[0].message
                          : null
                      }
                    />
                  </Grid>
                  <Grid
                    className="griditem"
                    item
                    lg={12}
                    xl={12}
                    sm={12}
                    md={12}
                    xs={12}
                    sx={{ paddingBottom: "10px" }}
                  >
                    <CustomeForm
                      sx={{
                        "&.MuiOutlinedInput-root.Mui-disabled": {
                          "& > fieldset": { boder: "none" }
                        }
                      }}
                      type={showPassord ? 'text' : 'password'}
                      className="textfield"
                      label={t("PassWord")}
                      id="pass"
                      name="password"
                      size="medium"
                      // className="textfield"
                      // label={t("PassWord")}
                      error={inputsValues.errorArray[0].password}
           
                  
                      onChange={e => handleChange(e)}
                    
                      helperText={
                        inputsValues.errorArray[1].password
                          ? inputsValues.errorArray[1].message
                          : null
                      }
                      InputProps={{
                        endAdornment: (
                            <InputAdornment position="start">
                                <IconButton
                                    aria-label="toggle password visibilty"
                                    onClick={handleClickShowPassword}
                                    // onMouseDown={handleMouseDownPassword}
                                    edge="start"
                                >
                                    {showPassord?  <Visibility />:<Visibilityoff />}
                                </IconButton>
                            </InputAdornment>
                        )
                    }}
                    />
                  </Grid>

                  <Link href={constants.forgetPasswordLink} passHref className={style.forgetPassword}>
                 
                      <p className={style.paraforgetPassword}>
                        {t("forgetPassword")}
                      </p>
                  
                  </Link>

                  <Grid
                    className="griditem"
                    item
                    lg={12}
                    xl={12}
                    sm={12}
                    md={12}
                    xs={12}
                    style={{}}
                  >
                    <Stack direction="row" spacing={2}>
                      <Customebtn
                        loadingPosition="start"
                        loading={loading}
                        sx={{ color: "white" }}
                        variant="outlined"
                        type={"submit"}
                      >
                        {t("Singin")}
                      </Customebtn>
                    </Stack>
                    {/*  <Button variant="contained" type="submit" fullWidth size="large" className='signinbtn'>{t("Singin")}</Button> */}
                  </Grid>
                  <p className={style.parforgetPassword}>
                    {t("DonothaveAnaccount")}
                    <Link href={constants.signUpLink} passHref className={style.AtagIcon}>
                      {t("SignUp")}
                    </Link>
                  </p>
                </Grid>
              </div>
            </form>
          </div>
          <div className={style.card1}>
            <img
              className={style.loginimg}
              src={`${config.basePath}/assest/loginImage.png`}
            />
          </div>
        </div>
      </div>
      <AlertDialog open={responseMessgae.show} text={responseMessgae.message}
                         type={responseMessgae.type}
                         btnOk={()=>{responseMessgae["show"]=false,setResponseMessage({...responseMessgae})
                        
 
                        }}
                         />
    </div>
    :""}
    {/* {showActivateAccount.show==true?<Active data={showActivateAccount}/>:""} */}
    </>
  );
}

export default LoginHome;
